// extracted by mini-css-extract-plugin
export default {"description":"Description_description__I8ajw","title":"Description_title__c4IGw"};